var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgArrowLeft = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "interface-arrows-button-up--arrow-up-keyboard",
    clipPath: "url(#clip0_237_2944)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M7.24913 9.64288L2.85627 5.25003C2.82211 5.21796 2.79488 5.17924 2.77626 5.13624C2.75765 5.09324 2.74805 5.04688 2.74805 5.00003C2.74805 4.95317 2.75765 4.90681 2.77626 4.86382C2.79488 4.82082 2.82211 4.78209 2.85627 4.75003L7.24913 0.357169",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_237_2944"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 10,
    fill: "white",
    transform: "matrix(0 -1 1 0 0 10)"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgArrowLeft);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/arrow_left.b364ce29505c7789f3b209f6e371e192.svg";